/**
 * Tour pacing. One file, so the rhythm of the guided flow is a set of numbers
 * a person can read and change, not a scatter of magic values across the
 * provider and the entry sequence.
 *
 * Owner brief, 2026-08-21: the first run must feel calm. The failure mode it
 * names is a window that changes faster than the user can follow, so every
 * constant here buys the eye a beat between one thing ending and the next
 * beginning. They are deliberately generous; the user can always press Next.
 */

/** After a `navigate` step lands on its route, before advancing to the step
 *  that renders on it. Was 60ms, which read as a flicker: the route changed
 *  and a coachmark was already talking. */
export const NAVIGATE_SETTLE_MS = 700;

/** After a route change, before the first anchor resolution attempt. Lets the
 *  incoming page paint so the spotlight opens on a drawn surface rather than
 *  on a half-mounted one. */
export const ROUTE_PAINT_MS = 350;

/** Between the portal door animation finishing and the first consent dialog.
 *  The door ends on a held frame; the dialog should not collide with it. */
export const DOOR_TO_CONSENT_MS = 500;

/** Between the mandatory consent dialog closing and the optional one opening.
 *  Two dialogs swapping in the same frame reads as one dialog that glitched. */
export const CONSENT_STEP_GAP_MS = 600;

/** Between the last consent decision and the tour's first coachmark. The user
 *  has just finished a form; the tour should not pounce. */
export const CONSENT_TO_TOUR_MS = 1200;
